var map = {
	"./decidim/avatar-multiuser.png": 92102,
	"./decidim/brands/facebook.svg": 70416,
	"./decidim/brands/google.svg": 78921,
	"./decidim/brands/twitter-x.svg": 18914,
	"./decidim/cc-badge.png": 75928,
	"./decidim/decidim-logo.svg": 92132,
	"./decidim/default-avatar.svg": 59100,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 35400,
	"./decidim/icons.svg": 89559,
	"./decidim/pattern.png": 34360,
	"./decidim/placeholder-card-g.svg": 2301,
	"./decidim/placeholder-card-l.svg": 50614,
	"./decidim/placeholder.jpg": 95253,
	"./decidim/remixicon.symbol.svg": 1177,
	"./decidim/vendor/social-share-button/douban.svg": 64760,
	"./decidim/vendor/social-share-button/email.svg": 78325,
	"./decidim/vendor/social-share-button/facebook.svg": 57483,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 38309,
	"./decidim/vendor/social-share-button/hacker_news.svg": 49125,
	"./decidim/vendor/social-share-button/linkedin.svg": 41325,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 20990,
	"./decidim/vendor/social-share-button/pinterest.svg": 17451,
	"./decidim/vendor/social-share-button/reddit.svg": 91967,
	"./decidim/vendor/social-share-button/telegram.svg": 14962,
	"./decidim/vendor/social-share-button/tumblr.svg": 5585,
	"./decidim/vendor/social-share-button/twitter.svg": 34020,
	"./decidim/vendor/social-share-button/vkontakte.svg": 92474,
	"./decidim/vendor/social-share-button/wechat.svg": 65445,
	"./decidim/vendor/social-share-button/whatsapp.svg": 68085,
	"./decidim/vendor/social-share-button/x.svg": 26293,
	"./decidim/vendor/social-share-button/xing.svg": 18603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65213;